import * as TYPES from './facility-actiontypes';

export const facilityLogoLoaded = (logo) => ({
  type: TYPES.FACILITY_LOGO_LOADED,
  state: {
    logo,
  },
});

export const facilityFaqsLoaded = (faqs) => ({
  type: TYPES.FACILITY_FAQ_LOADED_SUCCESS,
  state: {
    faqs,
  },
});

export const facilityFaqsLoadFailure = (error) => ({
  type: TYPES.FACILITY_FAQ_LOADED_FAILURE,
  state: {
    error,
  },
});

export const usefulLinksLoaded = (usefulLinks) => ({
  type: TYPES.USEFUL_LINKS_LOADED_SUCCESS,
  state: {
    usefulLinks,
  },
});

export const usefulLinksLoadFailure = (error) => ({
  type: TYPES.USEFUL_LINKS_LOADED_FAILURE,
  state: {
    error,
  },
});

export const downloadableFormsLoaded = (downloadableForms) => ({
  type: TYPES.DOWNLOADABLE_FORM_LOADED_SUCCESS,
  state: {
    downloadableForms,
  },
});

export const downloadableFormsLoadFailure = (error) => ({
  type: TYPES.DOWNLOADABLE_FORMS_LOADED_FAILURE,
  state: {
    error,
  },
});
